/* eslint-disable-next-line no-restricted-imports */
import * as t from 'io-ts';

export const tId = t.union([t.string, t.number]);

export type DeleteObject = {
  _destroy?: boolean;
  id: number;
};
